import { Button, Layout, Space, theme } from "antd";
import React, { useEffect } from "react";
import {
  getInterpretesSearch,
  initPrestationSlice,
  setPropertiesPrestation,
  updatePrestation,
} from "../Slices/Prestation.slice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import CustomTable from "../../../shared/components/CustomTable";
import { roles, statusPrestationsValues } from "../../../utils/constants";
import routes from "../../../engine/routes";
import {
  expandedRowRenderDetailInterpretes,
  prestationInterpretesColumns,
} from "./Prestation.interpretes.table";
import { TbUserSearch } from "react-icons/tb";
import { PrestationHeader } from "../../../shared/components/PrestationHeader/PrestationHeader";
import { isEqual } from "lodash";
import { askNewSearchInterpretesPrestation } from "../../../shared/components/Modals/modals";
import { keys } from "lodash/object";
import { PrestationInterpreteSelector } from "./Prestation.interprete.selector";
import { useTranslation } from "react-i18next";

const { Content, Sider, Header, Footer } = Layout;

export function PrestationInterpretes({ unitId, expanded, onClose, route }) {
  const { id } = useParams();

  const navigate = useNavigate();

  const location = useLocation();

  const { prestation, loading, interpretesHasSearch } = useSelector(
    state => state.prestation,
  );

  const getInterpretesSearchs = () => {
    dispatch(getInterpretesSearch(id));
  };

  useEffect(() => {
    if (prestation._id !== undefined) {
      const criteria = {
        "interpreteData.languages": prestation.languages[0],
        "info.genre": prestation.search.searchGenre,
        "interpreteData.interpretingMode": prestation.intervention.type,
        "interpreteData.institutionsToAvoid": prestation.institution._id.toString(),
        role: roles.interprete,
        status: "active",
        "interpreteData.level": prestation.search.searchLevel,
      };

      let previousSearch = prestation?.searchInterpretes?.criteria || null;

      // console.log(
      //   prestation,
      //   previousSearch,
      //   isEqual(criteria, previousSearch),
      // );

      if (previousSearch !== null) {
        if (!isEqual(criteria, previousSearch)) {
          askNewSearchInterpretesPrestation({
            onOk: getInterpretesSearchs,
            date: prestation?.searchInterpretes.dateSearch,
          });

          // Find differences
          // const changedKeys = keys(criteria).filter(
          //   key => !isEqual(criteria[key], previousSearch[key]),
          // );
          //
          // changedKeys.forEach(key => {

          // });
        } else {
        }

        // IF there is diff with loadh all key
      }
    }
  }, [prestation._id]);

  useEffect(() => {
    if (
      prestation.interpretesStatus.length === 0 &&
      interpretesHasSearch === false &&
      prestation._id !== undefined
    ) {
      getInterpretesSearchs();
    }
  }, []);

  const { init, clear } = initPrestationSlice({ id });

  const dispatch = useDispatch();

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const { name, archived } = prestation;
  const { t } = useTranslation();

  const inputs = [
    {
      parentLabel: "",
      children: [
        {
          label: t("prestationInterpretes.orderNumber"),
          name: "reference",
          required: true,
          disabled: true,
          capitalize: false,
          type: "input",
          value: prestation?.reference,
          variant: "important",
          col: 12,
        },
      ],
    },
  ];

  const renderSearchChild = () => {
    return <div>Search</div>;
  };

  const saveInterpretesSearch = async () => {
    let data = {};
    data.steps ??= {};

    data.steps.complements = true;

    await dispatch(setPropertiesPrestation(data));
    await dispatch(updatePrestation());
    await navigate(routes.prestations(id).detailInformations.path);
  };

  const sortingInterpretes = (a, b) => {
    // Define the sorting order for statuses
    const statusOrder = {
      selected: 1,
      invited: 2,
      relance: 3,
      refused: 4,
      not_invited: 5,
      not_available: 5,
      // Add other statuses here with their respective sort order
      // For example:
      // 'accepted': 2,
    };

    // Default to a high sort order if status is not recognized
    const aStatusOrder = statusOrder[a.status] || 99;
    const bStatusOrder = statusOrder[b.status] || 99;

    // First sort by status
    if (aStatusOrder !== bStatusOrder) {
      return aStatusOrder - bStatusOrder;
    }

    // If statuses are the same, then sort by position
    if (a.position !== b.position) {
      return a.position - b.position;
    }

    // If positions are the same, then sort by totalScore
    if (a?.totalScore !== b?.totalScore) {
      return a?.totalScore - b?.totalScore; // Lower scores first
    }

    // If positions are the same, then sort by cost
    return a.cost - b.cost;
  };

  // critere par qualifications et distance

  const renderResultsString = () => {
    return (
      <p>
        {!loading ? (
          <>
            {prestation.interpretesStatus.length > 0 && (
              <>
                <b>
                  {prestation?.interpretesStatus.length}{" "}
                  {prestation?.interpretesStatus.length > 1
                    ? t("prestationInterpretes.interpreters")
                    : t("prestationInterpretes.interpreter")}
                </b>{" "}
                {t("prestationInterpretes.respondingToYourSearchCriteria")}{" "}
                {prestation.interpretesStatus.length > 1
                  ? t("prestationInterpretes.are")
                  : t("prestationInterpretes.is")}{" "}
                {t("prestationInterpretes.available")}
              </>
            )}

            {prestation?.interpretesStatus.length === 0 &&
              t("prestationInterpretes.noInterpreterMatchesSearchCriteria")}
          </>
        ) : (
          <span className={"loadingdots"}>...</span>
        )}
      </p>
    );
  };

  const searchButton = () => (
    <Button
      disabled={prestation.status !== statusPrestationsValues.draft}
      type={"primary"}
      size={"large"}
      onClick={getInterpretesSearchs}
      loading={loading}
      icon={<TbUserSearch size={20} />}
    >
      {t("prestationInterpretes.searchInterpreter")}
    </Button>
  );

  return (
    <div id={"printable"}>
      <PrestationHeader
        title={routes.prestations(id).detailInterpretes.title}
      />

      {/*<Skeleton active title={"Hello"} paragraph={"hdhdhdhd"} />*/}

      <>
        <Space
          style={{
            marginTop: "10px",
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {renderResultsString()}
          {searchButton()}
        </Space>

        <CustomForm
          disabled={loading}
          initialValues={prestation}
          dataSource={inputs}
          labelCol={24}
          wrapperCol={24}
        />

        <CustomTable
          emptyText={
            <>
              <p>{t("prestationInterpretes.clickHereToSearchInterpreters")}</p>
              {searchButton()}
            </>
          }
          loading={loading}
          smTitle={item => {
            return (
              <div className={"alignHeaderPage"}>
                <h2 className={"noMargin"}>{item.user}</h2>
              </div>
            );
          }}
          scroll={{ y: 1000, x: 1000 }}
          rowKey={i => i.interprete._id}
          columns={prestationInterpretesColumns(prestation)}
          customRowClassName={record => {
            return record.status === "refused" ||
              record.status === "not_invited" ||
              record.status === "not_available"
              ? "rowOpacity"
              : "";
          }}
          hasPagination={true}
          dataSource={prestation.interpretesStatus
            .filter(e => e.hidden === false)
            .sort(sortingInterpretes)}
          expandable={{
            // expandRowByClick: true,
            expandedRowRender: expandedRowRenderDetailInterpretes,
            rowExpandable: record => record.name !== "Not Expandable",
          }}
        />
        <PrestationInterpreteSelector />

        <div style={{ textAlign: "right", paddingTop: 15 }}>
          <Button
            disabled={
              prestation.interpretesStatus.length === 0 ||
              (prestation.status !== statusPrestationsValues.draft &&
                prestation.status !== statusPrestationsValues.waiting)
            }
            onClick={saveInterpretesSearch}
            size={"middle"}
            type={"primary"}
          >
            {t("prestationInterpretes.saveAndNext")}
          </Button>
        </div>
      </>
    </div>
  );
}
